export default __webpack_public_path__ + "static/media/logo_SVS_new_SHORT.1fb107dc.svg";